export enum ConfigurationItems {
    DriverWebsiteUrl = 'DriverWebsiteUrl',
    ManagerWebsiteUrl = 'ManagerWebsiteUrl',
}
